
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'EditIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: '#2196F3',
        },
        className: {
            type: String,
            default: '',
        },
    },
})
